import React, { FC } from 'react';
import {
  Image,
  Linking,
  Pressable,
  useWindowDimensions,
  View,
} from 'react-native';
import {
  app_store,
  email_white,
  fax_white,
  google_play,
  logo,
  phone_white,
} from '../../assets/base64';
import { FONTS } from '../../constants';
import { IS_WEB, MAX_WIDTH } from '../../constants/platform';
import { STYLE_VARS } from '../../constants/style-vars';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { Text } from '../Text';

export const Footer: FC = () => {
  const { width } = useWindowDimensions();
  return (
    <View
      style={{
        backgroundColor: STYLE_VARS.primaryColor,
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <View
        style={[
          { flexDirection: 'column', alignItems: 'center', width: '100%' },
          width > 770 && {
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            maxWidth: MAX_WIDTH,
            paddingHorizontal: 20,
            alignItems: 'flex-start',
            paddingTop: 90,
          },
        ]}
      >
        <Image
          source={{ uri: addBase64Prefix(logo) }}
          style={{
            width: 105,
            height: 105,
            marginTop: width > 770 ? 0 : 70,
            marginBottom: width > 770 ? 0 : 45,
          }}
        />

        <View
          style={[
            { flexDirection: 'column' },
            width > 480 &&
              width <= 770 && {
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                paddingHorizontal: '20%',
              },
            width > 770 && {
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'space-around',
            },
          ]}
        >
          <View
            style={[
              { flexDirection: 'column', alignItems: 'center' },
              width > 770 && { alignItems: 'flex-start' },
            ]}
          >
            <Text
              style={{
                color: '#ffffff',
                fontSize: 16,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 20,
              }}
            >
              CONTACT US
            </Text>

            <Pressable
              onPress={() => Linking.openURL('tel:+(852)34737000')}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: 15,
              }}
            >
              <Image
                source={
                  IS_WEB
                    ? addBase64Prefix(phone_white)
                    : require('../../assets/phone-white.png')
                }
                style={{ width: 18, height: 18, marginRight: 5 }}
              />
              <Text
                style={{
                  color: '#ffffff',
                  fontSize: 16,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                }}
              >
                {'(852) 3473 7000'}
              </Text>
            </Pressable>

            <Pressable
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: 15,
              }}
              onPress={() => Linking.openURL('tel:+(852)34737000')}
            >
              <Image
                source={
                  IS_WEB
                    ? addBase64Prefix(fax_white)
                    : require('../../assets/fax-white.png')
                }
                style={{ width: 18, height: 18, marginRight: 5 }}
              />
              <Text
                style={{
                  color: '#ffffff',
                  fontSize: 16,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                }}
              >
                {'(852) 3473 7000'}
              </Text>
            </Pressable>

            <Pressable
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: width > 770 ? 0 : 50,
              }}
              onPress={() => Linking.openURL('mailto:info@kcc.org.hk')}
            >
              <Image
                source={
                  IS_WEB
                    ? addBase64Prefix(email_white)
                    : require('../../assets/email-white.png')
                }
                style={{ width: 18, height: 18, marginRight: 5 }}
              />
              <Text
                style={{
                  color: '#ffffff',
                  fontSize: 16,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                }}
              >
                {'info@kcc.org.hk'.toUpperCase()}
              </Text>
            </Pressable>
          </View>

          <View
            style={[
              { flexDirection: 'column' },
              width <= 480 && { alignItems: 'center' },
            ]}
          >
            <Text
              style={{
                color: '#ffffff',
                fontSize: 16,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 20,
              }}
            >
              ABOUT US
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 8,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/about/');
              }}
            >
              ABOUT KCC
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 8,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/sports-recreation/');
              }}
            >
              SPORTS & RECREATION
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 8,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/news/');
              }}
            >
              NEWS
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 8,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/dining/');
              }}
            >
              DINING
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 8,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/membership/');
              }}
            >
              KCC MEMBERSHIP
            </Text>

            <Text
              style={{
                color: '#ffffff',
                fontSize: 12,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: width > 770 ? 0 : 40,
              }}
              onPress={() => {
                Linking.openURL('https://kcc.org.hk/about/careers/');
              }}
            >
              CAREERS
            </Text>
          </View>
        </View>

        {IS_WEB && (
          <View style={{ flexDirection: 'column', alignItems: 'center' }}>
            <Text
              style={{
                color: '#ffffff',
                fontSize: 16,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                paddingBottom: 20,
              }}
            >
              DOWNLOAD OUR MEMBERS APP
            </Text>

            <Image
              source={{ uri: addBase64Prefix(app_store) }}
              style={{ width: 135, height: 40, marginBottom: 4 }}
            />
            <Image
              source={{ uri: addBase64Prefix(google_play) }}
              style={{ width: 135, height: 40 }}
            />
          </View>
        )}
      </View>

      <View style={{ marginTop: 40, flexDirection: 'row' }}>
        <Text
          style={{ color: '#ffffff' }}
          onPress={() => {
            Linking.openURL('https://kcc.org.hk/terms-of-use/');
          }}
        >
          {'TERMS & CONDITIONS'}
        </Text>
        <Text style={{ color: '#ffffff', marginHorizontal: 5 }}>{'|'}</Text>
        <Text
          style={{ color: '#ffffff' }}
          onPress={() => {
            Linking.openURL('https://kcc.org.hk/privacy-policy/');
          }}
        >
          {'PRIVACY POLICY'}
        </Text>
        <Text style={{ color: '#ffffff', marginHorizontal: 5 }}>{'|'}</Text>
      </View>

      <Text
        style={{
          color: '#ffffff',
          marginTop: 4,
          textAlign: 'center',
          marginBottom: 20,
          paddingHorizontal: 20,
        }}
      >
        Copyright © 2023 Kowloon Cricket Club, Hong Kong. All rights reserved.
      </Text>
    </View>
  );
};
